import { useState, useRef, useEffect } from 'react';

export default function StartRepair({ onBack, onStart }) {
  const [input, setInput] = useState('');
  const textareaRef = useRef(null);

  useEffect(() => {
    textareaRef.current?.focus();
  }, []);

  function handleSubmit(e) {
    e.preventDefault();
    const text = input.trim();
    if (!text) return;

    onStart({
      service: text,
      difficulty: 'Unknown',
      description: `User-initiated repair: ${text}`,
      costDealer: 'Unknown',
      costShop: 'Unknown',
      costDIY: 'Unknown',
      source: 'start_repair',
    });
  }

  return (
    <div className="screen" style={{ padding: 0, display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Header */}
      <div
        style={{
          padding: '16px 20px',
          borderBottom: '1px solid var(--border)',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          flexShrink: 0,
        }}
      >
        <button
          onClick={onBack}
          style={{
            width: 36,
            height: 36,
            borderRadius: 'var(--radius-sm)',
            background: 'var(--bg-card)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h1 style={{ fontSize: '1.125rem', fontWeight: 700, margin: 0 }}>Start Repair</h1>
      </div>

      {/* Content */}
      <div style={{ flex: 1, padding: '24px 20px', overflowY: 'auto' }}>
        {/* Icon */}
        <div style={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: 'var(--accent-subtle)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 16px',
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" />
          </svg>
        </div>

        <h2 style={{ textAlign: 'center', fontSize: '1.0625rem', fontWeight: 600, marginBottom: 8 }}>
          What repair or maintenance are you about to perform?
        </h2>
        <p style={{ textAlign: 'center', color: 'var(--text-secondary)', fontSize: '0.8125rem', marginBottom: 24, lineHeight: 1.5 }}>
          Describe the job and we'll generate a personalized guide with tools, parts, and step-by-step instructions.
        </p>

        <form onSubmit={handleSubmit}>
          <textarea
            ref={textareaRef}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder={'Oil change, timing belt, coolant flush, etc.\nYou can type multiple jobs at once...'}
            style={{
              width: '100%',
              minHeight: 120,
              padding: '14px 16px',
              borderRadius: 'var(--radius-md)',
              border: '1px solid var(--border)',
              background: 'var(--bg-card)',
              color: 'var(--text-primary)',
              fontSize: '0.9375rem',
              lineHeight: 1.5,
              resize: 'vertical',
              fontFamily: 'inherit',
              boxSizing: 'border-box',
            }}
          />

          <button
            type="submit"
            disabled={!input.trim()}
            className="btn btn-primary"
            style={{
              width: '100%',
              marginTop: 16,
              padding: '14px',
              fontSize: '0.9375rem',
              fontWeight: 600,
              opacity: input.trim() ? 1 : 0.5,
            }}
          >
            Get Started
          </button>
        </form>
      </div>
    </div>
  );
}
